import React, { useEffect, useState } from "react";
import DeliveryInProgress from "../components/DeliveryInProgress";
import VerifiedNavigation from "../../navigation/components/VerifiedNavigation";
import FullHistory from "../components/FullHistory";
import { OrderServices } from "../services/OrderServices";

const History = () => {
  const [orders, setOrders] = useState([]);

  const fetchOrders = async () => {
    const response = await OrderServices.fetchOrders();
    setOrders(response.data);
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  return (
    <div className="order-history">
      <VerifiedNavigation />
      <div className="order-history-container">
        <h2>Order History</h2>
        <DeliveryInProgress orders={orders} />
        <FullHistory orders={orders} />
      </div>
    </div>
  );
};

export default History;
